// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2GbdE","name":"Header_name__1Gly7","birthday":"Header_birthday__YSRah","skeleton":"Header_skeleton__2B2SU"};